import api from "./api";
import { saveAs } from "./fileSaver";

export const CATEGORY_LABELS = {
    busta_paga: "Busta paga",
    cu_730: "CU / 730",
    contratto: "Contratto",
    certificato: "Certificato formazione",
    comunicazione: "Comunicazione",
    visita_medica: "Visita medica",
    documento_identita: "Documento identità",
    unilav: "Ricevuta UNILAV",
    atti: "Atti",
    altro: "Altro",
};

export const CATEGORY_ORDER = [
    "busta_paga",
    "cu_730",
    "contratto",
    "certificato",
    "comunicazione",
    "visita_medica",
    "documento_identita",
    "unilav",
    "atti",
    "altro",
];

export const formatBytes = (bytes) => {
    if (!bytes) return "0 B";
    const units = ["B", "KB", "MB", "GB"];
    let val = bytes;
    let i = 0;
    while (val >= 1024 && i < units.length - 1) {
        val /= 1024;
        i++;
    }
    return `${val.toFixed(val >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
};

export const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleString("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch (e) {
        return iso;
    }
};

export const downloadDocument = async (docId, filename, opts = {}) => {
    const params = {};
    if (opts.acknowledged) params.acknowledged = true;
    try {
        const res = await api.get(`/documents/${docId}/download`, {
            responseType: "blob",
            params,
        });
        saveAs(res.data, filename || "documento");
    } catch (err) {
        // Axios returns the error body as a Blob when responseType is "blob".
        // Convert it back to JSON so the caller gets `error.response.data.detail`
        // shape (matches normal API errors).
        const resp = err?.response;
        if (resp && resp.data && typeof resp.data.text === "function") {
            try {
                const text = await resp.data.text();
                resp.data = JSON.parse(text);
            } catch (e) {
                // leave as-is if not JSON
            }
        }
        throw err;
    }
};
